import React from "react";
import { ChevronLeft, ChevronRight } from "./Icons";

export default function MonthNavigator({ monthName, year, isCurrentMonth, onPrev, onNext }) {
  return (
    <div className="flex items-center justify-between px-5 py-3 bg-white border-b border-gray-100 flex-shrink-0">
      <button
        onClick={onPrev}
        className="w-9 h-9 rounded-full bg-[#FDC700]/15 flex items-center justify-center text-[#FDC700] hover:bg-[#FDC700]/25 active:bg-[#FDC700]/35 transition-colors"
      >
        <ChevronLeft />
      </button>

      <span className="text-base font-bold text-gray-800">
        {monthName} {year}
      </span>

      <button
        onClick={onNext}
        disabled={isCurrentMonth}
        className={`w-9 h-9 rounded-full flex items-center justify-center transition-colors ${
          isCurrentMonth
            ? "text-[#FDC700]/30 bg-[#FDC700]/5 cursor-not-allowed"
            : "text-[#FDC700] bg-[#FDC700]/15 hover:bg-[#FDC700]/25 active:bg-[#FDC700]/35"
        }`}
      >
        <ChevronRight />
      </button>
    </div>
  );
}